import { FC } from "react";

import AddMediaDialog from "@src/features/app/dialogs/addMedia/AddMediaDialog";
import Sparkles2FillIcon from "@src/lib/icons/18px/sparkles-2-fill";
import { Button } from "@src/lib/ui/Button";
import { LinkType } from "@src/lib/utils/files";
import { cn } from "@src/lib/utils/cn";
import useImportPdfIntoDocument from "../hooks/useImportPdfIntoDocument";

type Props = {
  trainingResourceId: string | null | undefined;
  size?: "sm" | "default";
  className?: string;
};

/** Picks a PDF (uploaded or an existing resource) to turn into this doc. */
const ImportFromPdfButton: FC<Props> = ({
  trainingResourceId,
  size = "default",
  className,
}) => {
  const { handleImportPDF, handleImportResource } =
    useImportPdfIntoDocument(trainingResourceId);
  return (
    <AddMediaDialog
      title="Import from PDF"
      filterResources={[LinkType.PDF]}
      onMediaChange={handleImportPDF}
      onResourceChange={handleImportResource}
      disableFileTypeSelect
      uploadAccept=".pdf"
      trigger={
        <Button
          variant="outline"
          size={size}
          className={cn(
            "flex items-center justify-center gap-2 text-purple-8",
            className,
          )}
          dataTestId="resource-import-from-pdf"
        >
          <Sparkles2FillIcon className={size === "sm" ? "size-3" : "size-4"} />
          Import from PDF
        </Button>
      }
    />
  );
};

export default ImportFromPdfButton;
